import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_cursor_hand_light.svg';
import Icon, { IconProps } from './icon';

const IconCursorHandLight = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCursorHandLight;
